export default __webpack_public_path__ + "static/media/Group16.c8df04db.png";